import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
// import VueAuth from '@websanova/vue-auth'
import NProgress from 'vue-nprogress'
import { sync } from 'vuex-router-sync'
import App from './App.vue'
import router from './router'
import store from './store'
import * as filters from './filters'
import ToggleButton from 'vue-js-toggle-button'
import { TOGGLE_SIDEBAR } from 'vuex-store/mutation-types'

// const ROUTE_ROLES = {
//   'Administrator': 1,
//   'Client': 2,
//   'Anonymous': 3
// }

Vue.router = router
Vue.use(ToggleButton)
Vue.use(VueAxios, axios)
// Vue.use(VueAuth, {
//   auth: {
//     request: function (req, token) {
//       this.options.http._setHeaders.call(this, req, {Authorization: 'Bearer ' + token})
//     },
//     response: function (res) {
//       // Get Token from response body
//       return res.data.auth.token
//     }
//   },
//   http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
//   router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
//   loginData: { url: 'http://localhost:8093/api/auth/sign-in', fetchUser: false },
//   refreshData: { enabled: false }
// })

Vue.use(NProgress)
// Enable devtools
Vue.config.devtools = true

sync(store, router)

const nprogress = new NProgress({ parent: '.nprogress-container' })

const { state } = store

// Roles (binary)
//  000001 - SuperAdmin  (1)
//  000010 - Admin  (2)
//  000100 - Partner (4)
//  001000 - Referrer (8)
//  010000 - Client (16)
//  100000 - Anonymous (32)

const PAGE_MAPPER = {
  'Пользователь': 31,
  'Данные пользователя': 31,
  'Пользователи': 15,
  'Новый пользователь': 3,
  'Клиенты': 7,
  'Параметры клиента': 7,
  'Архив рассылок': 23,
  'Рассылки': 31,
  'Новая рассылка': 23,
  'Копия рассылки': 23,
  'Рассылка': 23,
  'Сценарии': 23,
  'Сценарий': 23,
  'Новый сценарий': 23,
  'Номера на прозвон': 23,
  'Мониторинг рассылки': 23,
  'Тестовые номера': 23,
  'Лицевой счет клиента': 31,
  'Результат теста': 23,
  'Авторизация': 63,
  'Регистрация': 63,
  'Настройка прав': 1,
  'Настройка приложения': 1
}

router.beforeEach((to, from, next) => {
  if (state.app.device.isMobile && state.app.sidebar.opened) {
    store.commit(TOGGLE_SIDEBAR, false)
  }
  // next()
  const role = store.getters.loggedRole
  const toPathRoleGate = PAGE_MAPPER[to.name]
  console.log(role + '-' + toPathRoleGate)
  if ((role & toPathRoleGate) > 0) {
    next()
  } else if (store.getters.isLogged) {
    next('/campaigns')
  } else {
    next('/login')
  }
})

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

const app = new Vue({
  router,
  store,
  nprogress,
  ...App
})

export { app, router, store }



// WEBPACK FOOTER //
// ./client/app.js